// Fills the free shipping bar in the shipping options drawer
// (snippets/shipping-options-drawer.liquid) each time it opens.
//
// The drawer is rendered with the page, so its own copy of the bar would go
// stale as soon as something is added to the cart. The cart drawer's bar is
// re-rendered on every cart change (see cart.js), so it is copied from there.
// An empty bar (empty cart, no threshold) hides itself via :empty in CSS.

const SHIPPING_MODAL = '#ShippingOptionsModal';
const FREE_BAR_SLOT = '[data-shipping-free-bar]';
const CART_FREE_BAR = 'cart-drawer .free-shipping-bar';

document.addEventListener(
  'click',
  (event) => {
    if (!event.target.closest(`modal-opener[data-modal="${SHIPPING_MODAL}"]`)) return;

    const slot = document.querySelector(`${SHIPPING_MODAL} ${FREE_BAR_SLOT}`);
    if (!slot) return;

    const cartBar = document.querySelector(CART_FREE_BAR);
    slot.replaceChildren();
    if (cartBar && cartBar.childElementCount > 0) slot.append(cartBar.cloneNode(true));
  },
  true
);
